/**
 * The frame clock: the time at the start of the frame, the frame's length in
 * 60 fps frames for the physics and uncapped, and the frame count. index
 * advances it once per frame through update; everything else reads it
 * through the read-only view.
 */
interface Clock {
  /** performance.now() at the start of the frame. */
  time: number;
  /** The frame's length in 60 fps frames, capped at 10 for the physics. */
  timeFactor: number;
  /** The frame's length in 60 fps frames, capped at 60 despite the name legacy gave it. */
  timeFactorUncapped: number;
  /** Frames advanced since load. */
  frames: number;
}

/** update writes here; readers get the view below. */
const clockState: Clock = { time: 0, timeFactor: 1, timeFactorUncapped: 1, frames: 0 };
export const clock: Readonly<Clock> = clockState;

const MAX_UNCAPPED_FRAMES = 60;
const MAX_PHYSICS_FRAMES = 10;

/** Advances the clock by the frames since the last one, capping the physics factor at 10 and the other at 60. */
export function update(framesDelta: number) {
  clockState.timeFactorUncapped = Math.min(framesDelta, MAX_UNCAPPED_FRAMES);
  clockState.timeFactor = Math.min(clockState.timeFactorUncapped, MAX_PHYSICS_FRAMES);
  clockState.time = performance.now();
  clockState.frames++;
}
